module.exports = __webpack_public_path__ + "img/19200.f402768f.jpg";